import storage from '../utils/storage'
/**
 * This plugin is used to migrate the app's local storage when the build version changes.
 * It checks the current build version against the stored version in local storage.
 * If the versions are different, it clears specific keys from local storage and updates the stored version.
 * The keys that are cleared are defined in the `clearKeys` array.
 * The current build version is obtained from the runtime configuration.
 * The plugin also provides the current build version and the storage object to the Nuxt app.
 */

/**
 * MOTIVATION:
 * 1. The app's local storage may contain data that is no longer relevant or compatible with the new build version.
 * 2. By clearing specific keys, we ensure that the app starts with a clean slate for the new build version.
 * 3. This helps prevent potential issues that may arise from using outdated or incompatible data.
 */

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig()
  const buildVersion = config.public.buildVersion || 'next'
  try {
    const storedVersion = storage.getItem('app:buildVersion')
    const clearKeys = [
      'app:config:adSettings',
      'app:config:SiteSettings',
      'app:config:LayoutSettings',
      'app:buildVersion',
    ]
    if (buildVersion !== storedVersion) {
      clearKeys.forEach((key) => {
        storage.removeItem(key)
      })
      storage.setItem('app:buildVersion', `${buildVersion}`)
    }
    // eslint-disable-next-line
  } catch (error) {
    /* empty */
  }
  nuxtApp.provide('buildVersion', buildVersion)
  nuxtApp.provide('storage', storage)
})
